export const isDev = () => process.env.NODE_ENV === "development";

export const CONFIG = {
  // GOOGLE_TAG_MANAGER_ID: "GTM-P5M7QKBF",
  paypalClientId: isDev()
    ? "AZ29s7c66asw7CjqS2vSHKeUDfmGtuio9cV1pxxrEOFiyUM-uyA2xmVJnDg6PM7iQ7SFa0AAWDk6Y5It"
    : "AULNj2NFIEiao7xy4hpcmv8yQEGHBiyolalq9xWQ1q8Thl1UlJGpavLiAQ0i7u50Zmsh_kii4DZJBuAC",
  turnstileSiteKey: "0x4AAAAAAA8VmnRFZmSHt6W1",
  statsigClientKey: "client-MT7leA6ir31PneIyD4biReXFtCuei7bUWQmxZYKuruA",
};
